import { render } from "./returnvisit.vue?vue&type=template&id=6577dd02&ts=true"
import script from "./returnvisit.vue?vue&type=script&lang=ts"
export * from "./returnvisit.vue?vue&type=script&lang=ts"

import "./returnvisit.vue?vue&type=style&index=0&id=6577dd02&lang=scss"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__